import { organizationRoleList } from './const';
import { OrganizationRole } from './types';

export const connectionIdValueTypeGuard = (value: unknown): void => {
    if (typeof value === 'number' && !isNaN(value)) return;

    throw new TypeError(`Invalid value provided for the connectionId: '${value}'`);
};

export const existedOrganizationRoleGuard = (value: OrganizationRole): void => {
    if (organizationRoleList.includes(value)) return;

    throw new TypeError(`Unsupported Organization Role: ${value}`);
};
